var map = {
	"./female-avatar.png": 599,
	"./login_logo.png": 200,
	"./logo.png": 600,
	"./male-avatar.png": 601,
	"./torre-logo.png": 201
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 598;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.png$
// module id = 598
// module chunks = 0